import React from 'react';
import FooterContact from '../../components/Footer/FooterContact';
import AllProjects from '../../components/ProjectsPage/ProjectsInfo';

export default function About() {
  return (
    <div>
      <AllProjects />
      <FooterContact />
    </div>
  );
}
